import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { SectionCard } from '../components/SectionCard'

export function FormSection({
  title,
  icon,
  description,
  children,
}: {
  title: string
  icon: ReactNode
  description?: string
  children: ReactNode
}) {
  return (
    <SectionCard title={title} icon={icon} description={description}>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{children}</div>
    </SectionCard>
  )
}

export function SwitchCard({
  checked,
  onChange,
  title,
  hint,
}: {
  checked: boolean
  onChange: (v: boolean) => void
  title: string
  hint?: string
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={cn(
        'flex w-full items-start justify-between gap-4 rounded-xl border p-4 text-left transition-colors',
        checked ? 'border-primary/40 bg-primary/5' : 'border-border/70 bg-muted/20 hover:bg-muted/40',
      )}
    >
      <span className="min-w-0">
        <span className="block text-sm font-medium">{title}</span>
        {hint ? <span className="mt-0.5 block text-xs text-muted-foreground">{hint}</span> : null}
      </span>
      <span
        aria-hidden
        className={cn(
          'relative mt-0.5 inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors',
          checked ? 'bg-primary' : 'bg-muted-foreground/30',
        )}
      >
        <span
          className={cn(
            'absolute size-4 rounded-full bg-card shadow-sm transition-transform',
            checked ? 'translate-x-[18px]' : 'translate-x-0.5',
          )}
        />
      </span>
    </button>
  )
}
